import React from 'react';
import PropTypes from 'prop-types';
import i22c from 'assets/images/i22c.svg';
import { Trans } from 'components';

function getClass(type) {
  switch(type) {
    case "success": return { className: "succeed", title: "Sukces"};
    case "warning": return { className: "warning", title: "Ostrzeżenie"};
    case "error": return { className: "failure", title: "Błąd" };
    case "info":
    default: return { className: "neutral", title: "Info"};
  }
}

const Toastr = ({ text, type, remove }) => {
  const { className, title } = getClass(type);

  return (
    <div id="snackbar-container">
      <div className={`snackbar toast snackbar-opened ${className}`}>
        <span className="snackbar-label"><Trans>{title}</Trans></span>
        <span className="snackbar-content">{text}</span>
        <span className="snackbar-btns">
        <button className="small-btn" type="button" onClick={remove}>
          <img src={i22c} alt="" />
        </button>
        </span>
      </div>
    </div>
  );
};

Toastr.propTypes = {
  text: PropTypes.any.isRequired,
  type: PropTypes.string.isRequired,
  remove: PropTypes.func,
};

export default Toastr;


// WEBPACK FOOTER //
// ./src/components/Toastr.jsx